import { createFileRoute, redirect } from '@tanstack/react-router';

// RFC-098: Redirect to new compliance review queue
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/evidence/review-queue')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/compliance/reviews',
      params: { workspaceId: params.workspaceId },
    });
  },
});
